import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

export default function LoadingCard({ message = "Fetching data..." }) {
  return (
    <div className="flex items-center justify-center min-h-[400px] w-full p-4">
      <motion.div 
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white dark:bg-slate-800 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-700 p-8 flex flex-col items-center justify-center max-w-sm w-full"
      >
        <div className="relative mb-6">
          <div className="absolute inset-0 bg-primary-100 dark:bg-primary-900/30 rounded-full animate-ping opacity-75"></div>
          <div className="relative bg-primary-50 dark:bg-slate-700 p-4 rounded-full">
            <Loader2 className="w-10 h-10 text-primary-600 animate-spin" />
          </div>
        </div>
        <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">Please Wait</h3>
        <p className="text-slate-500 dark:text-slate-400 text-center text-sm">{message}</p>
      </motion.div>
    </div>
  );
}
